<template>

  <div class="polygon">
    <l-polygon ref="element"
               :lat-lngs="latlngs"
               :fillColor="color"
               :color="color"
               :weight="weight"
               :bubblingMouseEvents="false"
               :options="{ editable: true }"
               @contextmenu="contextmenu($event)"
               @click="click($event)">
    </l-polygon>
  </div>

</template>

<script>

import { LPolygon } from 'vue2-leaflet'
import { MapService } from '../../services/map.service.es6'

export default {
  name: 'map-polygon',

  props: [ 'element', 'active' ],

  data () {
    return {
      editable: false,
      menu: [
        { title: this.$t('map.element.edit'), icon: 'pen', action: () => this.editable = true },
        { title: this.$t('map.element.remove'), icon: 'trash', action: () => MapService.removeElement(this.element) }
      ]
    }
  },

  computed: {
    color () {
      return this.active ? '#FF0000' : '#333333'
    },

    weight () {
      return this.active ? 3 : 1
    },

    latlngs () {
      return this.element.locations.map(x => [ x.lat, x.lng ])
    }
  },

  methods: {
    click(event) {
      this.$emit('click', event)
    },

    contextmenu (event) {
      this.$emit('menu', { event: event, data: this.menu })
    },
  },

  watch: {
    active (value) {
      if (this.editable && !value) {
        this.editable = false
        this.$emit('save', { locations: this.$refs.element.mapObject._latlngs[0] })
      }
    },

    editable (value) {
      const editor = this.$refs.element.mapObject.enableEdit()

      if (value)
        editor.enable()
      else
        editor.disable()
    }
  },

  components: {
    LPolygon
  }
}
</script>
